<header class="header" [class.hidden]="sidebarService.isFilterMenuOpen()">
    <div class="block-yellow hamburger" (click)="onMenuButtonClick()">
        <img src="../../../assets/images/hamburger.png" [alt]="'HEADER.MENU' | translate">
    </div>
    <div class="block-black left-action logo-projecto-ayuntamiento">
        <img class="logo-ayuntamiento" src="../../../assets/logos/logo_proyecto_ayuntamiento.svg">

    </div>
    <div class="block-center logos" alt="Logos europeos">
        <img class="logo-europe" src="../../../assets/logos/logos_horizontal.svg">
    </div>
    <div class="block-black right-action back-button" [class.back-button]="showBackButton"
        (click)="showBackButton && goBack()">
        @if (showBackButton) {
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fcc200"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
        <span class="back-text">{{'HEADER.BACK' | translate}}</span>
        }
    </div>
    <div class="block-yellow language" (click)="toggleLanguage()">
        <p>
            <strong [class.active-lang]="currentLang === 'es'">ES</strong>
            /
            <strong [class.active-lang]="currentLang === 'en'">EN</strong>
        </p>
    </div>
</header>
